module.exports = __webpack_public_path__ + "img/Room5_001.fe0babb5.svg";